/**
 * Parse a date string (YYYY-MM-DD) as a LOCAL date, avoiding UTC timezone shift.
 * 
 * Problem: new Date("2026-05-31") is interpreted as UTC midnight,
 * which shifts to May 30th in US timezones (e.g., EST, CST, PST).
 * 
 * Solution: Split the string and use the Date(year, month, day) constructor
 * which creates dates in the local timezone.
 */
export const parseLocalDate = (dateStr) => {
  if (!dateStr) return null;
  if (dateStr instanceof Date) return dateStr;
  const str = String(dateStr);
  if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
    const [year, month, day] = str.split('T')[0].split('-').map(Number);
    return new Date(year, month - 1, day);
  }
  return new Date(dateStr);
};

/**
 * Format a date string as a locale date string, timezone-safe.
 */
export const formatDate = (dateStr, options) => {
  const d = parseLocalDate(dateStr);
  if (!d) return '—';
  return d.toLocaleDateString('en-US', options);
};
